import { render } from "./RecommendedSearchesWidget.vue?vue&type=template&id=1c252c7c&scoped=true"
import script from "./RecommendedSearchesWidget.vue?vue&type=script&lang=js"
export * from "./RecommendedSearchesWidget.vue?vue&type=script&lang=js"

import "./RecommendedSearchesWidget.vue?vue&type=style&index=0&id=1c252c7c&lang=scss&scoped=true"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c252c7c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QChip,QCard,QSkeleton});
